import { render, staticRenderFns } from "./DatatableBodyCell.vue?vue&type=template&id=1323f951&"
import script from "./DatatableBodyCell.vue?vue&type=script&lang=js&"
export * from "./DatatableBodyCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports